import axios from "axios";
import { API_URL, NEW_API_URL } from "../constants/Globals";
import { isUserHasValidRoleForGroup } from "./GroupSvc";

export const fetchClientSubscriptions = (clientId) => {
  return axios.get(
    `${NEW_API_URL}/master/subscription-types/client/${clientId}/features`
  );
};

export async function afterSideBarNetworkChange(networkId) {
  console.log("Network changed to::::::::::", networkId);
  try {
    const res = await fetchClientSubscriptions(networkId);
    console.log("Response from fetching network features:", res.data);
    if (res.data && res.data.status === 1) {
      localStorage.setItem(
        "networkSubscriptionFeatures",
        JSON.stringify(res.data.data)
      );
    }
  } catch (err) {
    console.error("Error fetching network features:", err);
  }
}

export async function isSubscriptionFeatureLocked(
  featureSlug,
  checkSuperAdminRole = false
) {
  let isSubscriptionFeatureLocked = true;

  if (checkSuperAdminRole) {
    const isUserSuperAdmin = await isUserHasValidRoleForGroup(0, "SUPERADMIN");
    if (isUserSuperAdmin) {
      return false;
    }
  }

  const featuresLockUnlockData = JSON.parse(
    localStorage.getItem("networkSubscriptionFeatures")
  );
  if (featuresLockUnlockData && Array.isArray(featuresLockUnlockData)) {
    const feature = featuresLockUnlockData.find((f) => f.slug === featureSlug); // adjust slug as needed
    console.log("Access status by subscription:: ", feature);
    isSubscriptionFeatureLocked = feature?.isLocked || false;
  }

  return isSubscriptionFeatureLocked;
}

export async function getClientOrganization(networkId) {
  const url = `${API_URL}/admin/client/${networkId}`;
  const groupId = await axios
    .get(url)
    .then((res) => {
      // console.log('Client group detail:::::::::::: ', res.data.data.groups[0]);
      const groupId = res?.data?.data?.groups?.[0]?.id;
      if (groupId) {
        return groupId;
      } else {
        alert("No organization found for network!");
        return 0;
      }
    })
    .catch((err) => {
      alert("There is a problem in fetching network detail. Please try again!!");
      console.log(err);
    });
  return groupId;
}
